module.exports = __webpack_public_path__ + "static/media/face_2_default.8afe9bcb.svg";